import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'

export const wrapper = css`
  position: relative;
`

export const floating = css`
  transition: filter 0.2s ease-in-out;
  will-change: filter;
  block-size: inherit;
  z-index: 1;
`

export const blockStart = css`
  position: fixed;
  inset-block-start: 0;
  inset-block-end: unset;
  inset-inline-start: 0;
  inset-inline-end: 0;
  filter: drop-shadow(${cssTheme.shadows.bottomNormal});
`

export const blockEnd = css`
  position: fixed;
  inset-block-start: unset;
  inset-block-end: 0;
  inset-inline-start: 0;
  inset-inline-end: 0;
  filter: drop-shadow(${cssTheme.shadows.topNormal});
`
